import Vue from "vue";
import "./pollyfills";
import VueRouter from "vue-router";
import VueRouterPrefetch from "vue-router-prefetch";
import VeeValidate from "vee-validate";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import App from "./App.vue";
import VueMoment from "vue-moment";
import Loading from "vue-loading-overlay";
import Notifications from "vue-notification";
import vSelect from "vue-select";

import "element-ui/lib/theme-chalk/index.css";
import { Icon } from "leaflet";
import "leaflet.icon.glyph";
import "leaflet/dist/leaflet.css";

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/UIComponents/SidebarPlugin";
import initProgress from "./progressbar";

// router setup
import routes from "./routes/routes";

// library imports

import "./assets/sass/paper-dashboard.scss";
import "./assets/sass/demo.scss";
import "vue-select/dist/vue-select.css";

import sidebarLinks from "./sidebarLinks";
import "./registerServiceWorker";

import store from "./store";

VeeValidate.Validator.localize("en", {
  custom: {
    refundType: {
      required: "Please choose a refund type"
    },
    keepConnectionActive: {
      required: "Please choose to keep connection open or not"
    },
    permissions: {
      required: "Please select atleast 1 Permission for this role"
    }
  }
});

import ElementUI from "element-ui";

Vue.use(ElementUI);
// plugin setup
Vue.use(VueRouter);
Vue.use(VueRouterPrefetch);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(Notifications);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
Vue.use(VeeValidate);
Vue.use(VueMoment);
Vue.component("v-select", vSelect);
Vue.use(Loading, {
  color: "green",
  height: 150,
  width: 150,
  loader: "spinner"
});
// Vue.use(Notifications)
locale.use(lang);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  mode: "history",
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters["auth/loggedIn"]) {
      next({
        name: "Login"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters["auth/loggedIn"]) {
      next({
        name: "Overview"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

initProgress(router);
Vue.mixin({
  methods: {
    currencyFormatter() {
      // currencyFormatter().format(amount)
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      });
    },
    notifyVue(title, text, type) {
      this.$notify({
        group: "general",
        title: title,
        text: text,
        type: type,
        duration: -1
      });
    }
  }
});

/* eslint-disable no-new */
new Vue({
  store,
  el: "#app",
  render: h => h(App),
  router
});
